import React from "react";
//#region types
import { TodoCardProps } from "models/propTypes/todoPropTypes";
//endregion
//#region components/
import DocumentDraft from "components/documents/documentDraft/documentDraft";
import { useTodoService } from "serviceHooks";
//#endregion

const DocumentDraftTodo: React.FC<TodoCardProps> = (props) => {
  const todoService = useTodoService();
  const documentDraft = props.item.documentDraft;

  return documentDraft ? (
    <DocumentDraft
      documentDraft={documentDraft}
      reloadHandler={props.onActionSuccess}
      statusIndicatorDisplayType={todoService.getUIDisplayTypeByUrgency(props.item.urgency)}
    />
  ) : (
    <></>
  );
};

export default DocumentDraftTodo;
